import React, { useState, useEffect } from 'react';
import { Canvas } from '@react-three/fiber';
import { Preload } from '@react-three/drei';
import { LanguageProvider } from './contexts/LanguageContext';
import Layout from './components/Layout';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import PortfolioSection from './components/PortfolioSection';
import ClientsSection from './components/ClientsSection';
import ContactSection from './components/ContactSection';
import Scene from './components/3D/Scene';
// Splash screen removed

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth) * 2 - 1,
        y: -(e.clientY / window.innerHeight) * 2 + 1
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <LanguageProvider>
      <div className={`${isDarkMode ? 'dark' : ''}`}>
        <div className="relative">
          {/* 3D Background Canvas */}
          <div className="fixed inset-0 -z-10">
            <Canvas
              camera={{ position: [0, 0, 5], fov: 50 }}
              style={{ position: 'fixed' }}
            >
              <Scene mousePosition={mousePosition} isDarkMode={isDarkMode} />
              <Preload all />
            </Canvas>
          </div>

          {/* Content Sections with proper IDs for navigation */}
          <div className="relative z-10">
            <Layout isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}>
              {/* Home Section */}
              <section id="home" className="scroll-mt-20">
                <HeroSection />
              </section>
              
              {/* Services Section */}
              <section id="services" className="scroll-mt-20">
                <ServicesSection />
              </section>
              
              {/* Portfolio/Success Stories Section */}
              <section id="portfolio" className="scroll-mt-20">
                <PortfolioSection />
              </section>
              
              {/* Clients Section - Not in main navigation but still accessible */}
              <section id="clients" className="scroll-mt-20">
                <ClientsSection />
              </section>
              
              {/* Contact Section */}
              <section id="contact" className="scroll-mt-20">
                <ContactSection />
              </section>
            </Layout>
          </div>
        </div>
      </div>
    </LanguageProvider>
  );
}

export default App;